import { useState } from 'react'

import { PopoverMenu } from '@factorialco/deprecated-design-system'

import Chip from 'modules/core/components/Filter/base/Chip'
import Provider from 'modules/core/components/Filter/base/Provider'

interface EntityFilterProps<T> {
  value: T[]
  label: string
  defaultOpen?: boolean
  children: React.ReactNode
  onChange: (value: T[]) => void
}

export function EntityFilter<T>({
  label,
  value,
  onChange,
  children,
  defaultOpen,
}: EntityFilterProps<T>) {
  const [popoverOpen, togglePopover] = useState(defaultOpen ?? false)

  const onClose = () => {
    togglePopover(false)
  }

  return (
    <PopoverMenu type="dialog" onClick={togglePopover} open={popoverOpen}>
      <Provider
        value={value}
        onValueChange={onChange}
        closeOnChange={false}
        defaultOpen={!!popoverOpen}
        onClose={onClose}
      >
        <PopoverMenu.Trigger>
          <Chip.Toggler
            active={value.length > 0}
            label={label}
            activeLabel={`(${value.length})`}
            onToggle={togglePopover}
          />
        </PopoverMenu.Trigger>

        <PopoverMenu.Content width="full" side="bottom" align="center" offset={0}>
          {children}
        </PopoverMenu.Content>
      </Provider>
    </PopoverMenu>
  )
}
